import store from '@/state/store'
const fields = [
  {
    key: 'sentOn',
    label: 'global.field.date',
    header: 'date',
    disabled: true,
    filter: false,
    width: 30,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
  },
  {
    key: 'imei',
    label: 'report.fields.imei',
    header: 'imei',
    filter: false,
    width: 20,
  },
  {
    key: 'deviceType',
    label: 'report.fields.deviceType',
    header: 'deviceType',
    filter: false,
    width: 20,
  },
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: false,
    width: 20,
  },
  {
    key: 'latitude',
    label: 'report.fields.latitude',
    header: 'latitude',
    filter: false,
    width: 30,
  },
  {
    key: 'longitude',
    label: 'report.fields.longitude',
    header: 'longitude',
    filter: false,
    width: 30,
  },
  {
    key: 'address',
    label: 'report.fields.location',
    header: 'address',
    filter: false,
    width: 30,
    tdClass: 'address-td',
  },
  {
    key: 'speed',
    label: 'report.fields.speed',
    header: 'speed',
    filter: false,
    width: 10,
  },
  {
    key: 'acc',
    label: 'report.object.acc',
    header: 'acc',
    filter: false,
    width: 10,
  },
]
if (store.getters['identity/hasAccess'](['detail_history_vehicle_geofence_column:read'])) {
  fields.splice(9, 0, {
    key: 'geofence',
    label: 'report.fields.geolocation',
    header: 'geofence',
    filter: false,
    width: 30,
  })
}

if (store.getters['identity/hasAccess'](['report_vehicle_trip_voltage:read'])) {
  fields.push({
    key: 'accuVoltage',
    label: 'report.fields.voltage',
    header: 'accuVoltage',
    filter: false,
    width: 30,
  })
}

export default fields
